import { render, staticRenderFns } from "./urlshortener-debug.vue?vue&type=template&id=230142dd"
import script from "./urlshortener-debug.vue?vue&type=script&lang=js"
export * from "./urlshortener-debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports